import type {BioIconProps} from '../../icons/common-types'
import {FlagIconsUS} from '../../icons/flag-icons-us'

export default function AmericanBest10Logo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M7.6538 21.3332C7.80046 20.6798 7.5338 19.7465 7.06713 19.2798L3.82713 16.0398C2.8138 15.0265 2.4138 13.9465 2.70713 13.0132C3.0138 12.0798 3.96046 11.4398 5.3738 11.1998L9.5338 10.5065C10.1338 10.3998 10.8671 9.8665 11.1471 9.31984L13.4405 4.71984C14.1071 3.39984 15.0138 2.6665 16.0005 2.6665C16.9871 2.6665 17.8938 3.39984 18.5605 4.71984L20.8538 9.31984C21.0271 9.6665 21.3871 9.99984 21.7738 10.2265L7.4138 24.5865C7.22713 24.7732 6.90713 24.5998 6.96046 24.3332L7.6538 21.3332Z"
          fill="white"
        />
        <path
          d="M24.9334 19.28C24.4534 19.76 24.1867 20.68 24.3467 21.3334L25.2667 25.3467C25.6534 27.0134 25.4134 28.2667 24.5867 28.8667C24.2534 29.1067 23.8534 29.2267 23.3867 29.2267C22.7067 29.2267 21.9067 28.9734 21.0267 28.4534L17.1201 26.1334C16.5067 25.7734 15.4934 25.7734 14.8801 26.1334L10.9734 28.4534C9.4934 29.32 8.22673 29.4667 7.4134 28.8667C7.10673 28.64 6.88007 28.3334 6.7334 27.9334L22.9467 11.72C23.5601 11.1067 24.4267 10.8267 25.2667 10.9734L26.6134 11.2C28.0267 11.44 28.9734 12.08 29.2801 13.0134C29.5734 13.9467 29.1734 15.0267 28.1601 16.04L24.9334 19.28Z"
          fill="white"
        />
      </svg>
      <span>American Best 10</span>
      <FlagIconsUS className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5" />
    </div>
  )
}
